
































































import Person from '@/types/Person.interface'
import Vue, { PropType } from 'vue'
export default Vue.extend({
    props: {
        exclude: {
            type: Array,
            default: null
        },
        expand: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        persons: {
            type: Array as PropType<Person[]>,
            default: []
        }
    },
    data: () => ({
        viewMore: false
    }),
    computed: {
        //  Depending on our screen size we either render 2 or 3 rows to have the broadcast component better fit the screen
        allowedRows(): number {
            if (this.$vuetify.breakpoint.smAndDown){
                return 2
            }
            else {
                return 3
            } 
        },
        canMesssageUsers(): boolean {
            // Checks if our message users setting is enabled or not
            return this.$store.getters.settingGet('usersInsideInbox')
        },
        filteredPersons(): Person[] {
            //  Grab our persons
            const persons = this.persons

            //  If there aren't any, return empty array
            if (!persons) return []

            //  If the workspace doesn't have the message users in inbox enabled we filter out any user from the result, otherwise we allow users to be in the result
            const noUsers = !this.canMesssageUsers ? persons.filter((x: Person) => !x.user_id) : persons

            //  Remove opt outs
            const noOptOuts = noUsers.filter(
                ({ phone_default }) => !this.optedOut.includes(phone_default?.msisdn)
            )

            //  Get our exclusion persons
            const exclude = this.exclude || []

            //  Remove our excluded persons
            const filtered = noOptOuts.filter(({ id }) => !exclude.includes(id))

            //  Return our filtered persons
            return filtered
        },
        optedOut(): number[] {
            return this.$store.getters.optedOut
        }
    },
    methods: {
        onPersonSelected(person: Person): void {
            //  Tell the parent about our selection
            this.$emit('personSelected', person)
        },
        personName(name: string): string {
            //  If it doesn't exist just return an empty string
            if (!name) return ''

            //  If our name is 15 characters or less, just return the name
            if (name.length <= 15) return name

            //  Else, concatenate and append ellipses
            return name.substring(0, 15) + '...'
        },
        phone(person: Person): string {
            //  If number does not exist, return nothing (for users)
            if (!person.phone_default) return

            //  Grab the msisdn from this person
            const msisdn = person.phone_default.msisdn

            //  Make our phone all pretty
            const phone = this.$options.filters.phone(msisdn)

            //  Return the prettified :) phone number
            return phone
        }
    }
})
